import { render, staticRenderFns } from "./PriceSuggestionLogList.vue?vue&type=template&id=7f71d44c&"
import script from "./PriceSuggestionLogList.vue?vue&type=script&lang=js&"
export * from "./PriceSuggestionLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f71d44c')) {
      api.createRecord('7f71d44c', component.options)
    } else {
      api.reload('7f71d44c', component.options)
    }
    module.hot.accept("./PriceSuggestionLogList.vue?vue&type=template&id=7f71d44c&", function () {
      api.rerender('7f71d44c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/price-suggestion-log/PriceSuggestionLogList.vue"
export default component.exports